import React from "react";
import Balancer from "react-wrap-balancer";

const Services = () => {
  // services details
  const services = [
    {
      name: "Web App Development",
      desc: "Specializing in dynamic web applications using React, Next.js, and Firebase to bring your vision to life.",
      icon: "fas fa-palette",
    },
    {
      name: "Mobile App Development",
      desc: "Crafting intuitive mobile experiences with Flutter and SwiftUI, tailored for both iOS and Android platforms.",
      icon: "fas fa-desktop",
    },
    {
      name: "Mentoring",
      desc: "Imparting real-world practices and insights from my rich journey as a seasoned developer.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Consultation Services in Digital Infrastructures and Artificial Intelligence use cases",
      desc: "Leveraging extensive experience to strategize and optimize your digital and AI endeavors.",
      icon: "fas fa-chart-area",
    },
    {
      name: "Computer Science Exam Preparation",
      desc: "Training aspirants with modern, results-driven methodologies to conquer their CS exams.",
      icon: "fas fa-book",
    }
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <Balancer>
          <div className="row gy-5 mt-5">
            {services.length > 0 &&
              services.map((service, index) => (
                <div
                  className={`col-sm-6 col-lg-4 wow fadeInUp shadow-sm p-3 mb-2 rounded ${services.length - index <= 2 ? "mx-auto" : ""}`}
                  key={index}>
                  <div className="featured-box text-center px-md-4">
                    <div className="featured-box-icon text-primary mb-3">
                      <i className={`${service.icon} fa-3x`} />
                    </div>
                    <h3 className="text-7 fw-bold mb-3 text-uppercase text-dark">{service.name}</h3>
                    <p className="text-muted mb-0 fs-5">{service.desc}</p>
                  </div>
                </div>
              ))}
          </div>
        </Balancer>
      </div>
    </section >
  );
};

export default Services;
